import { Injectable } from "@angular/core";
import { Network } from "@ionic-native/network";
import { Events, Platform } from "ionic-angular";

export enum ConnectionStatusEnum {
  Online,
  Offline,
}

@Injectable()
export class AppStatus {
  appStatus: ConnectionStatusEnum = ConnectionStatusEnum.Online;

  constructor(
    public network: Network,
    public eventCtrl: Events,
    private platform: Platform
  ) {
    this.initAppStatus();
  }

  public initAppStatus() {
    let isOffline: boolean;
    if (this.platform.is("cordova") && this.network.type) {
      isOffline = this.network.type === "none";
    } else {
      isOffline = !window.navigator.onLine;
    }
    this.appStatus = isOffline
      ? ConnectionStatusEnum.Offline
      : ConnectionStatusEnum.Online;
  }

  public getAppStatus(): ConnectionStatusEnum {
    return this.appStatus;
  }

  public isOffline(): boolean {
    return this.appStatus === ConnectionStatusEnum.Offline;
  }

  public forceEmitAppNetworkStatus() {
    this.initAppStatus();
    this.eventCtrl.publish("networkchange", { status: this.appStatus });
  }

  public initializeNetworkEvents(): void {
    if (!this.platform.is("cordova")) {
      return;
    }
    console.log("initializing networks in app status");
    this.network.onDisconnect().subscribe(
      () => {
        console.log("network disconnected in app status");
        this.appStatus = ConnectionStatusEnum.Offline;
        this.eventCtrl.publish("networkchange", { status: this.appStatus });
      },
      (error) => {
        console.error("error while subscribing to onDisconnect in app", error);
      }
    );
    this.network.onConnect().subscribe(
      () => {
        console.log("network connected in app status");
        this.appStatus = ConnectionStatusEnum.Online;
        this.eventCtrl.publish("networkchange", { status: this.appStatus });
      },
      (error) => {
        console.error("error while subscribing to onConnect in app", error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/app-status/app-status.ts